import {
    buildLocalBusinessSchema,
    buildBreadcrumbSchema,
    buildFAQSchema,
    buildSpeakableSchema,
} from "./schemas";
import type { SeoHeadProps } from "./SeoHead";
import { SITE_BASE } from "./siteUrl";

const BASE = SITE_BASE;
const URL = `${BASE}/`;

const FAQS = [
    { q: "What products does Arte Craft India manufacture?", a: "Arte Craft India manufactures pom poms, tassels, fringes, faux fur pom poms, designer tassels, felt pom poms and beaded patch fringes. All products are handcrafted in our Delhi facility and supplied wholesale to fashion, home-decor, accessory and craft brands." },
    { q: "What is the minimum order quantity (MOQ)?", a: "Our standard MOQ is 50 pieces per design, with even lower MOQs available for samples and trial orders. Bulk discounts begin at 500 pieces." },
    { q: "Do you export internationally?", a: "Yes — we export to 50+ countries including USA, UK, EU, Germany, France, UAE, Australia, Canada and Japan. Full export documentation, ISO quality certification and custom packaging provided." },
    { q: "Can you do custom OEM and private-label manufacturing?", a: "Yes — OEM and private-label manufacturing is one of our core services. Custom colours, sizes, materials, branded packaging and logo hang-tags available across all product lines." },
    { q: "How long does production take?", a: "Standard bulk orders ship in 7–15 working days. Custom OEM orders take 15–25 days depending on complexity. Express options available." },
];

export const HomeSeo: SeoHeadProps = {
    title: "Pom Poms, Tassels & Fringes Manufacturer Delhi | Arte Craft India",
    description:
        "Arte Craft India — Delhi's leading manufacturer & exporter of handcrafted pom poms, tassels, fringes, faux fur pom poms, designer tassels, felt pom poms and beaded patch fringes. Wholesale, OEM, ships worldwide. MOQ 50 pcs.",
    keywords:
        "pom poms manufacturer Delhi, tassels manufacturer Delhi, fringes supplier India, faux fur pom poms exporter, designer tassels India, felt pom poms wholesale, beaded patch fringes manufacturer, Arte Craft India, textile accessory manufacturer India, handmade craft accessories Delhi, wholesale tassels India, custom pom poms OEM, garment accessory manufacturer Delhi, fashion trim manufacturer India",
    canonical: URL,
    author: "Arte Craft India",
    robots: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",

    ogType: "website",
    ogUrl: URL,
    ogSiteName: "Arte Craft India",
    ogImage: `${BASE}/images/homepage-og.jpg`,
    ogImageAlt: "Arte Craft India — Delhi manufacturer of pom poms, tassels, fringes, faux fur, designer tassels, felt, beaded patches",
    ogLocale: "en_IN",
    ogLocaleAlternates: ["en_US", "en_GB", "en_AU", "en_AE", "en_CA"],

    twitterCard: "summary_large_image",
    twitterSite: "@ArteCraftIndia",
    twitterCreator: "@ArteCraftIndia",
    twitterImage: `${BASE}/images/homepage-twitter.jpg`,
    twitterImageAlt: "Arte Craft India multi-product manufacturer in Delhi",
    twitterLabel1: "Product lines",
    twitterData1: "Pom Poms · Tassels · Fringes · Faux Fur · Designer · Felt · Beaded",
    twitterLabel2: "MOQ",
    twitterData2: "50 pieces · Free samples · Ships to 50+ countries",

    aiBots: true,

    geoRegion: "IN-DL",
    geoPlacename: "Badarpur, New Delhi, India",
    geoPosition: "28.5045;77.2855",

    dublinCore: {
        title: "Pom Poms, Tassels & Fringes Manufacturer Delhi | Arte Craft India",
        creator: "Arte Craft India",
        subject: "Pom Poms, Tassels, Fringes, Faux Fur, Designer Tassels, Felt, Beaded Patch — Manufacturing Delhi India",
        description:
            "Arte Craft India — multi-product textile accessory manufacturer & exporter based in Delhi. Wholesale, OEM, 50+ countries.",
        publisher: "Arte Craft India, Delhi",
        date: "2026-05-26",
        type: "Service, Manufacturer Profile",
        language: "en",
        rights: "© 2026 Arte Craft India. All rights reserved.",
    },

    hreflangs: [
        { lang: "en-IN", url: URL },
        { lang: "en-US", url: URL },
        { lang: "en-GB", url: URL },
        { lang: "en-CA", url: URL },
        { lang: "en-AU", url: URL },
        { lang: "en-AE", url: URL },
        { lang: "en", url: URL },
        { lang: "x-default", url: URL },
    ],

    googleVerification: process.env.REACT_APP_GOOGLE_VERIFICATION || undefined,
    bingVerification: process.env.REACT_APP_BING_VERIFICATION || undefined,
    yandexVerification: process.env.REACT_APP_YANDEX_VERIFICATION || undefined,

    themeColor: "#1B4F72",

    jsonLd: [
        buildLocalBusinessSchema(),
        buildBreadcrumbSchema([{ name: "Home", url: URL }]),
        buildFAQSchema(FAQS),
        buildSpeakableSchema(
            URL,
            "Pom Poms, Tassels & Fringes Manufacturer Delhi | Arte Craft India",
            "homepage"
        ),
    ],
};
